import styled from 'styled-components';
const PanelWrapper = styled.div `
  position: relative;

  ::before {
    background-color: var(--base-border-secondary);
    content: '';
    display: block;
    height: calc(100% - 24px);
    left: 7.5px;
    position: absolute;
    top: 32px;
    width: var(--border-b-seed);
  }

  :last-of-type::before {
    display: none;
  }
`;
export default PanelWrapper;
